const KEY_PREFIX = "refinement-canvas:thumbnail:";

export function loadCanvasThumbnail(canvasId: string): string | undefined {
  try {
    return window.localStorage.getItem(`${KEY_PREFIX}${canvasId}`) ?? undefined;
  } catch {
    return undefined;
  }
}

export function saveCanvasThumbnail(canvasId: string, dataUrl: string): void {
  try {
    window.localStorage.setItem(`${KEY_PREFIX}${canvasId}`, dataUrl);
  } catch {
    // サムネイルは補助情報のため、保存できない場合も編集を継続する。
  }
}
